export default function Products() {
  const products = [
    {
      icon: 'ri-shield-check-line',
      name: 'VPN Solutions',
      description: 'Secure browsing and privacy protection for iOS devices',
      bgColor: 'bg-gradient-to-br from-blue-50 to-purple-50',
      iconGradient: 'from-blue-500 to-purple-600'
    },
    {
      icon: 'ri-sparkling-line',
      name: 'Device Cleaner',
      description: 'Optimize storage and boost performance efficiently',
      bgColor: 'bg-gradient-to-br from-green-50 to-teal-50',
      iconGradient: 'from-green-500 to-teal-600'
    },
    {
      icon: 'ri-lock-line',
      name: 'Security Suite',
      description: 'Comprehensive protection for your mobile experience',
      bgColor: 'bg-gradient-to-br from-orange-50 to-red-50',
      iconGradient: 'from-orange-500 to-red-600'
    }
  ];

  return (
    <section id="products" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-extralight text-[#1a202c] mb-6">Our Products</h2>
          <p className="text-base text-[#a0aec0]">Innovative solutions for iOS users</p>
        </div>

        <div className="grid grid-cols-3 gap-10 mb-12">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-[28px] shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 p-12 cursor-pointer"
            >
              <div className={`relative ${product.bgColor} rounded-[28px] p-8 mb-8`}>
                <div className={`w-18 h-18 mx-auto flex items-center justify-center rounded-full bg-gradient-to-br ${product.iconGradient}`}>
                  <i className={`${product.icon} text-4xl text-white`}></i>
                </div>
              </div>

              <h3 className="text-3xl font-semibold text-[#1a202c] mb-5 text-center">
                {product.name}
              </h3>

              <p className="text-base text-[#718096] leading-relaxed text-center">
                {product.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-sm text-[#a0aec0] text-center mt-12">
          Trusted by thousands of iOS users worldwide
        </p>
      </div>
    </section>
  );
}